import {Controller} from '@hotwired/stimulus';

/* stimulusFetch: 'lazy' */
export default class extends Controller {

    static values = {
        url: String
    }

    static targets = ['menu', 'shareButton']

    async share() {
        if (navigator.share) {

            this.shareButtonTarget.classList.remove('cm-share')
            this.shareButtonTarget.classList.add('cm-refresh', 'animate-spin')
            try {
                await navigator.share({
                    title: 'Calciomercato.com',
                    url: this.urlValue,
                });
            } catch (e) {
                console.log('share aborted')
            }

            this.shareButtonTarget.classList.add('cm-share')
            this.shareButtonTarget.classList.remove('cm-refresh', 'animate-spin')

        } else {
            this._toggleMenu()
        }
    }

    _toggleMenu() {
        const e = this.menuTarget;
        e.hasAttribute('hidden') ? e.removeAttribute('hidden') : e.setAttribute('hidden', true)
    }

}